import { CONFIG } from '../../core/config';
import { ViewModel } from '../view-model';
import { Business } from './business-item';
import { Installation } from './installation-item';
import { PlantUnit } from './plant-unit-item';
import { SystemSection } from './system-section-item';

export class IndustryHierarchy implements ViewModel {
  readonly friendlyTypeNameSingular: string = 'Industry Hierarchy';
  readonly apiRoute: string = CONFIG.apiRoutes.industryHierarchy;

  modelId: string;
  businessId: string;
  businessItem: Business = new Business();
  installationId: string;
  installationItem: Installation = new Installation();
  plantUnitId: string;
  plantUnitItem: PlantUnit = new PlantUnit();
  systemSectionId: string;
  systemSectionItem: SystemSection = new SystemSection();

  json() {
    const jsonModel = {
      modelId: this.modelId,
      businessId: this.businessId,
      businessItem: this.businessItem,
      installationId: this.installationId,
      installationItem: this.installationItem,
      plantUnitId: this.plantUnitId,
      plantUnitItem: this.plantUnitItem,
      systemSectionId: this.systemSectionId,
      systemSectionItem: this.systemSectionItem,
    };
    jsonModel.installationItem.businessId = null;
    jsonModel.plantUnitItem.installationId = null;
    jsonModel.systemSectionItem.plantUnitId = null;

    return jsonModel;
  }

  loadFromJson(data: any) {
    this.modelId = data.modelId;
    this.businessId = data.businessId;
    if (data.businessItem) {
      this.businessItem = data.businessItem;
    }
    this.installationId = data.installationId;
    if (data.installationItem) {
      this.installationItem = data.installationItem;
    }
    this.plantUnitId = data.plantUnitId;
    if (data.plantUnitItem) {
      this.plantUnitItem = data.plantUnitItem;
    }
    this.systemSectionId = data.systemSectionId;
    if (data.systemSectionItem) {
      this.systemSectionItem = data.systemSectionItem;
    }
  }
}
